import * as firebase from 'firebase'
import api from './api'

class Firebase {

  constructor() {
    this.queue = []
    this.signedIn = false
    this.firebase = firebase.initializeApp({
      apiKey: 'AIzaSyBoAbqYUg8pnQ_uqkOtBmvmMqtk0yTC-SY',
      authDomain: 'badgeheroes-rateinc.firebaseapp.com',
      databaseURL: 'https://badgeheroes-rateinc.firebaseio.com',
      storageBucket: 'badgeheroes-rateinc.appspot.com',
      messagingSenderId: '981609015728',
    })
  }

  _signIn = id => ({ data: { firebase_access_token, client_id, team_id } }) => {
    this.client_id = 0
    this.team_id = team_id
    this.user_id = id
    this.firebase.auth().signInWithCustomToken(firebase_access_token).then(() => {
      this.signedIn = true
      this.queue.map(menu => this.new_click(menu))
    })
  }

  signIn = ({ id }) => {
    this.sign_in_at = new Date().valueOf()
    api.firebase_token(this._signIn(id))
  }

  signOut = () => {
    this.signedIn = false
    this.sign_out_at = new Date().valueOf()
    this._new_session()
  }

  _ref = () => this.firebase.database().ref()

  _set = (array_name, data) => {
    this._ref().child(`clients/${this.client_id}/${array_name}`).push().set(data)
  }

  new_click = (menu) => {
    if (this.signedIn) {
      this._set('clicks', {
        date: new Date().valueOf(),
        menu,
        uid: this.user_id,
        team_id: this.team_id,
      })
    } else {
      this.queue.push(menu)
    }
  }

  _new_session = () =>
    this._set('sessions', {
      duration: (this.sign_out_at - this.sign_in_at),
      start_date: this.sign_out_at,
      end_date: this.sign_in_at,
      team_id: this.team_id,
      uid: this.user_id,
    })

}

const singleton = new Firebase()

export default singleton



// WEBPACK FOOTER //
// ./src/middleware/firebase.jsx